export const initialData = () => ({});

export default {};
